import { cn } from "@util/tailwind";

interface AiThinkingAnimationProps {
    aiName?: string;
    className?: string;
    colorScheme?: 'default' | 'black';
}

export default function AiThinkingAnimation({
    aiName = "ourteam AI",
    className,
    colorScheme = 'default'
}: AiThinkingAnimationProps) {
    const isBlackScheme = colorScheme === 'black';
    
    const colorClasses = isBlackScheme ? {
        text: 'text-gray-600',
        dots: 'bg-gray-600'
    } : {
        text: 'text-blue-600',
        dots: 'bg-blue-600'
    };

    return (
        <div className={cn(
            "flex items-center gap-2 py-2 px-3 rounded-lg",
            "bg-gray-50/50 border border-gray-200/50",
            className
        )}>
            <div className={cn(
                "text-sm font-medium italic",
                colorClasses.text
            )}>
                {aiName} is thinking
            </div>
            <div className="flex gap-1">
                <div className={cn(
                    "w-1.5 h-1.5 rounded-full animate-bounce",
                    colorClasses.dots
                )} style={{ animationDelay: '0ms' }}></div>
                <div className={cn(
                    "w-1.5 h-1.5 rounded-full animate-bounce",
                    colorClasses.dots
                )} style={{ animationDelay: '150ms' }}></div>
                <div className={cn(
                    "w-1.5 h-1.5 rounded-full animate-bounce",
                    colorClasses.dots
                )} style={{ animationDelay: '300ms' }}></div>
            </div>
        </div>
    );
}